import type { PlanogramsTranslations } from "../en/Planograms";
import type { TranslationShape } from "../../store/types";

export const planogramsEs: TranslationShape<PlanogramsTranslations> = {
  pageTitle: "Planogramas Activos",
  pageSubtitle:
    "Visualiza y gestiona todos los planogramas activos en tiendas. Monitorea métricas de desempeño, revisa alertas y rastrea historial de versiones.",
  reports: "Reportes",
  exports: "Exportar",

  banner: {
    title: "Gestor de Planogramas",
    description:
      "Monitorea planogramas activos en todas las tiendas. Revisa el desempeño de layouts, verifica métricas de cumplimiento y atiende alertas. Haz clic en un ID de planograma para ver el historial de versiones.",
  },

  filters: {
    viewOn: "Ver en:",
    searchPlaceholder: "Buscar por tienda, ID...",
    filterPogs: "Filtrar POGs por:",
    showAs: "Mostrar como:",
    activeFilters: "Filtros activos:",
    clearAll: "Limpiar todo",
    cluster: "Cluster",
    store: "Tienda",
    category: "Categoría",
    search: "Búsqueda",
  },

  results: {
    showing: "Mostrando {{filtered}} de {{total}} planogramas",
    selected: "({{count}} seleccionados)",
  },

  columns: {
    storeCode: "Código de Tienda",
    storeStatus: "Estado",
    templateId: "ID Plantilla",
    activePlanogramId: "ID Planograma",
    returnOnSpace: "Retorno por Espacio",
    coreRange: "Rango Base",
    shelfAlignment: "Alineación de Estante",
    dogms: "DOGMS",
    size: "Tamaño",
    warnings: "Alertas",
    activeDate: "Fecha Activa",
    endDate: "Fecha Fin",
    lastEdited: "Última Edición",
    actions: "Acciones",
  },

  status: {
    pending: "Pendiente",
    active: "Activo",
    inactive: "Inactivo",
  },

  actions: {
    viewEdit: "Ver / Editar",
  },

  noResults: "No se encontraron planogramas",

  warnings: {
    title: "Alertas del Planograma",
    close: "Cerrar",
    none: "No hay alertas activas para este planograma",
    high: "Alta",
    medium: "Media",
    low: "Baja",
    types: {
      out_of_stock: "Sin Existencia",
      misplacement: "Mal Ubicado",
      shelf_compliance: "Cumplimiento de Estante",
      product_rotation: "Rotación de Producto",
      price_tag: "Etiqueta de Precio",
    },
  },

  history: {
    title: "Historial del Planograma",
    approvedBy: "Aprobado por:",
    activated: "Activado:",
    deactivated: "Desactivado:",
    close: "Cerrar",
    exportHistory: "Exportar Historial",
  },
};
